import React, { useState, useEffect } from "react";
import { Container, Button, Card, Row, Col } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { handleApiErrors } from "../../api/handleApiErrors";
import * as successCriteriaApi from './../../api/successCriteriaApi';
import { useSignalAbort } from '../../api/useSignalAbort';
import { useNavigate } from "react-router-dom";


function ClientSay() {
  const abortConstants = useSignalAbort()
  const navigate = useNavigate()
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState({});
  const [successList, setSuccessList] = useState([]);


  const captionStyle = {
    textAlign: "left",
    padding: "2px",
  };

  const captionTextStyle = {
    fontSize: "5rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#2855A1",
    marginTop: "2rem",
  };

  const captionTextStyle2 = {
    fontSize: "5rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "black",
  };

  const captionStyleheader = {
    textAlign: "center",
    padding: "2px",
    marginTop: "2rem",
  };

  const captionTextStyle3 = {
    fontSize: "1.1rem",
    textOverflow: "ellipsis",
    color: "black",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "3",
    marginBottom: "1rem", // Add margin for responsiveness
    marginTop: "1rem",
  };

  const imageStyle = {
    objectFit: "cover",
    alignItems: "left",
  };

  const responsiveCaptionTextStyle = {
    fontSize: "2rem", // Adjust font size for smaller screens
    whiteSpace: "normal", // Allow text to wrap on smaller screens
  };


  useEffect(() => {
    getAllData(abortConstants.controllerConfig)
  }, [])


  const getAllData = (abortToken) => {
    getAllSuccessbyCriteria(abortToken)
  }


  //Bloglist
  const getAllSuccessbyCriteria = async (abortToken) => {
    try {
      const result = await successCriteriaApi.getSuccessCriteria(abortToken)

      setSuccessList(result.data.SuccessStories)
      console.log(result.data.SuccessStories);
    }
    catch (error) {
      console.log(error);
      handleApiErrors(error, 'SuccessStoriesListing', 'successStoriesListing_response', 'successStoriesListing_timeout', 'successStoriesListing_request', setIsLoading);

    }
  }

  const handleNext = () => {
    setCount((prevCount) => (prevCount + 1) % successList.length);
  };

  const handlePrevious = () => {
    setCount((prevCount) =>
      prevCount === 0 ? successList.length - 1 : prevCount - 1
    );
  };


  return (
    <Container
      fluid
      style={{ backgroundColor: "#F7F9FF", marginTop: "60px", height: "auto" }}
    >
      <Container style={{ marginBottom: "20px" }}>
        <div style={captionStyle}>
          <h3 style={{ ...captionTextStyle, ...responsiveCaptionTextStyle }}>
            Our Clients
          </h3>
        </div>
      </Container>





      <Container style={{ marginTop: "50px", ...captionStyleheader }}>
        {/* {successList?.map((success) => ( */}
        <Row className="justify-content-center">

          <Col xs={12} md={12} lg={4}>
            <Image
              src={`${process.env.REACT_APP_BASE_URL}${successList[count]?.Image}`}
              alt=""
              style={{ ...imageStyle, width: "70%", height: '250px' }}
            />
          </Col>

          <Col xs={12} md={12} lg={5}>
            <Container>
              {/* <div
                  style={{
                    textAlign: "left",
                    marginTop: "20px",
                  }}
                >
                  <Image
                    src={process.env.PUBLIC_URL + "/assets/images/Q1.png"}
                    alt=""
                    style={{ ...imageStyle, width: "10%" }}
                  />
                </div> */}
              <div>
                <blockquote className="blockquote" style={captionTextStyle3}>
                  <p className="mb-3">
                    {successList[count]?.Content}
                  </p>
                  <span className="span subtext">
                    {successList[count]?.Title}

                    <div className="icon" onClick={() => {
                      const url = successList[count]?.ExternalUrl;
                      if (url) {
                        const formattedUrl = url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
                        window.location.href = formattedUrl;
                      }
                    }}>
                      <cite title="Source Title">
                        {" "}
                        {successList[count]?.ExternalUrl}{" "}
                      </cite>
                    </div>
                  </span>
                </blockquote>
              </div>

              {/* <div
                  style={{
                    textAlign: "right",
                    marginTop: "20px",
                  }}
                >
                  <Image
                    src={process.env.PUBLIC_URL + "/assets/images/Q2.png"}
                    alt=""
                    style={{ ...imageStyle, width: "10%" }}
                  />
                </div> */}
            </Container>
          </Col>


        </Row>
        {/* ))} */}

      </Container>


      {/* Pagination */}
      <Container>
        <div style={{ display: "flex", justifyContent: "flex-end", flexDirection: "row", alignItems: "end", marginBottom: "90px", marginTop: "10px" }}>
          <div className="icon">
            <Image
              src={process.env.PUBLIC_URL + "/assets/images/ArrowLeft.png"}
              alt=""
              style={{ objectFit: "cover", width: "50%", marginBottom: "20px" }}
              onClick={handlePrevious}
            />
          </div>
          <div className="icon">
            <Image
              src={process.env.PUBLIC_URL + "/assets/images/ArrowRight.png"}
              alt=""
              style={{ objectFit: "cover", width: "50%", marginBottom: "20px" }}
              onClick={handleNext}
            />
          </div>
        </div>

      </Container>


    </Container>
  );
}

export default ClientSay;
